import { CommunitySectionTooltipContent } from "@circleco/community-switcher/components/CommunitySectionTooltipContent";
import { CommunitySwitcherAvatar } from "@circleco/community-switcher/components/CommunitySwitcherAvatar";
import { getAutomaticLoginRootUrl } from "@circleco/community-switcher/helpers/utils";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { useCommunitySwitcherContext } from "../context/CommunitySwitcherContext";
import { getCommunitySwitcherIconUrl } from "../helpers/communitySwitcherItem";
import { SWITCHER_ICON_CLASS } from "./constants";

export const CommunitySwitcherCurrentCommunityLogo = () => {
  const { api, theme } = useCommunitySwitcherContext();
  const currentCommunity = api.currentCommunity;
  if (!currentCommunity) return null;

  const iconUrl = getCommunitySwitcherIconUrl(
    currentCommunity,
    theme.isDarkAppearance,
  );
  const href = getAutomaticLoginRootUrl(currentCommunity.root_url, api.token);
  return (
    <Tooltip
      content={<CommunitySectionTooltipContent name={currentCommunity.name} />}
      delay={200}
      side="right"
      sideOffset={12}
    >
      <span data-testid="community-switcher-item" className="inline-flex">
        <a
          aria-label={currentCommunity.name}
          className={SWITCHER_ICON_CLASS}
          data-community-switcher-nav=""
          data-testid="community-switcher-link"
          href={href}
        >
          <CommunitySwitcherAvatar
            iconUrl={iconUrl}
            name={currentCommunity.name}
            brandColor={currentCommunity.brand_color}
            lightBrandColor={currentCommunity.light_brand_color}
            darkBrandColor={currentCommunity.dark_brand_color}
          />
        </a>
      </span>
    </Tooltip>
  );
};
